<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold">{{$t('medium_grant_ev.esmsc__subtitle')}}</h4>
            <application-info></application-info>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-9">
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <p class="mt-3">{{$t('medium_grant_ev.esmsc__top_note')}}</p>

            <table class="table-bordered border-left-0 border-right-0 border-bottom-0 table-full-width mt-3" cellpadding="20">
              <tr>
                <th>{{$t('medium_grant_ev.esmsc__documents_submitted')}}</th>
                <th>
                  {{$t('medium_grant_ev.esmsc__documents_additional_describe')}}
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.describe_additional_documents"
      >
      </textarea>
                  </base-input>
                </th>
              </tr>
              <tr>
                <th colspan="2" class="pl-0 border-bottom-0 border-top-0 border-left-0 border-right-0">{{$t('medium_grant_ev.esmsc__clearance_decissions')}}</th>
              </tr>
              <tr>
                <td>
                  <base-checkbox name="checkbox" v-model="EvaluationForm.model.cleared">
                    {{$t('medium_grant_ev.esmsc__cleared')}}
                  </base-checkbox>
                </td>
                <td>
                  {{$t('medium_grant_ev.esmsc__cleared_info')}}
                </td>
              </tr>
              <tr>
                <td>
                  <base-checkbox name="checkbox" v-model="EvaluationForm.model.conditionally_cleared">
                    {{$t('medium_grant_ev.esmsc__conditionally_cleared')}}
                  </base-checkbox>
                </td>
                <td>
                  {{$t('medium_grant_ev.esmsc__conditionally_cleared_info')}}
                </td>
              </tr>
              <tr>
                <td>
                  <base-checkbox name="checkbox" v-model="EvaluationForm.model.clearance_rejected">
                    {{$t('medium_grant_ev.esmsc__clearance_rejected')}}
                  </base-checkbox>
                </td>
                <td>
                  {{$t('medium_grant_ev.esmsc__clearance_rejected_info')}}
                </td>
              </tr>
              <tr>
                <td>
                  {{$t('medium_grant_ev.esmsc__rationale')}}
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.rationale"
      >
      </textarea>
                  </base-input>
                </td>
              </tr>
              <tr>
                <td>
                  {{$t('medium_grant_ev.esmsc__clearance_condition')}}
                </td>
                <td>
                  <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.clearance_condition"
      >
      </textarea>
                  </base-input>
                </td>
              </tr>
            </table>

            <div class="mt-5">
              <p class="font-weight-bold mb-0">{{$t('medium_grant_ev.esmsc__clearance_completed_by')}}</p>
              <span v-if="EvaluationForm.evaluation && EvaluationForm.evaluation.user">{{EvaluationForm.evaluation.user.name}}</span>
              <span v-else>-</span>
            </div>

            <div class="mt-3">
              <div class="d-flex align-items-center">
                <p class="font-weight-bold mb-0">{{$t('medium_grant_ev.esmsc__clearance_signature')}}</p>
                <upload-file class="ml-5" v-model="EvaluationForm.files.esmsc.signature" :size-limit="EvaluationForm.fileSizeLimit" :is-evaluation="true" :file-data="EvaluationForm.files.esmsc.signature" :is-editable="EvaluationForm.isEditable" section="esmsc.signature"></upload-file>
              </div>
            </div>

            <table class="table-bordered table-full-width mt-5" cellpadding="20">
              <tr>
                <th>{{$t('medium_grant_ev.esmsc__checklist_for_clearance')}}</th>
                <th class="text-center" style="min-width: 250px;">
                  <a :href="downloadFiles[$i18n.locale]" class="link-download" target="_blank"> {{$t('medium_grant_ev.esmsc__download_template')}} </a>
                </th>
                <th class="text-center" style="min-width: 200px">
                  <upload-file v-model="EvaluationForm.files.esmsc.clearance" :size-limit="EvaluationForm.fileSizeLimit" :select-text="$t('medium_grant_ev.esmsc__upload_pdf')" :is-evaluation="true" :file-data="EvaluationForm.files.esmsc.clearance" :is-editable="EvaluationForm.isEditable" section="esmsc.clearance"></upload-file>
                </th>
              </tr>
            </table>
          </div>
        </div>

      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import ApplicationInfo from './ApplicationInfo';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      ApplicationInfo,
      CommentBox
    },
    data() {
      return {
        EvaluationForm,
        downloadFiles: {
          en: '/files/en/BIOPAMA_AC_STG_ESMS_Clearance_Template_checklist.docx',
          fr: '/files/en/BIOPAMA_AC_STG_ESMS_Clearance_Template_checklist.docx'
        }
      }
    },
    beforeCreate() {
      if (!EvaluationForm.files.esmsc) {
        EvaluationForm.files.esmsc = {};
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
<style>
  a.link-download {
    text-decoration: underline;
  }
</style>
